import { render, staticRenderFns } from "./add-to-wishlist.vue?vue&type=template&id=0036215a&scoped=true"
import script from "./add-to-wishlist.vue?vue&type=script&lang=js"
export * from "./add-to-wishlist.vue?vue&type=script&lang=js"
import style0 from "./add-to-wishlist.vue?vue&type=style&index=0&id=0036215a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036215a",
  null
  
)

export default component.exports